import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setState as quotaSetState } from "../../Approval/Quota/quotaApprovalSlice";
import { setState as quotaModSetState } from "../../Approval/QuotaModification/quotaModificationApprovalSlice";
import { setState as analyzeSetState } from "../../Analyze/analyzeSlice";
import { setState as scenarioApprovalState } from "../../Approval/Scenario/scenarioApprovalSlice";
import {setState} from "../dashBoardSlice"


export default function PendingAction({ text, number, link, category }) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { selectedCountry, selectedCountryID,approvalStats,isDashboard } = useSelector(
		(store) => store.dashboard
	);

  function getCurrentMonth() {
    const date = new Date();
    const options = { month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-US', options).replace(',', '');
}

	function navigateTo() {
		debugger;
		let linklocal=link;
		let selectedQuotaStatus="";
		let selectedQuotaStatusKey="";
		let selectedPeriod="";
		let duration="";
		let categoryLocal="";
		dispatch(quotaSetState("redirectedFromDashboardRejectedQuota", false));
    if (!link) return;
	    if(link.includes("Rejected")){
			dispatch(setState("isDashboard", true));
			linklocal = linklocal.replace("/Rejected", "");
			selectedQuotaStatus= "Rejected";
			selectedQuotaStatusKey= "4";
			selectedPeriod= getCurrentUpcomingPeriod(approvalStats.quotaSubRejPeriod,'QuotaRejected');
			dispatch(quotaSetState("redirectedFromDashboard", true));
			dispatch(quotaSetState("redirectedFromDashboardRejectedQuota", true));
		}
		else if (link.includes("quota-modification")) {
			dispatch(quotaModSetState("redirectedFromDashboard", true));
		} else if (link.includes("quota")) {
			dispatch(setState("isDashboard", true));
			selectedPeriod= getCurrentUpcomingPeriod(approvalStats.quotaSubRejPeriod,'QuotaPending');
			selectedQuotaStatus= "All except Approved/Rejected";
			selectedQuotaStatusKey= "0";
			//selectedQuotaStatus= "Submitted";
			//selectedQuotaStatusKey= "2";			
			dispatch(quotaSetState("redirectedFromDashboard", true));
		} else if (link.includes("analyze")) {
			debugger;
      dispatch(analyzeSetState("redirectedFromDashboard", true));
	  dispatch(analyzeSetState("duration", getCurrentMonth()));
	  dispatch(analyzeSetState("category", category));
       duration = getCurrentMonth();
       categoryLocal = category;
    } else if (link.includes("scenario")) {
		dispatch(setState("isDashboard", true));
      dispatch(scenarioApprovalState("redirectedFromDashboard", true));
	  dispatch(scenarioApprovalState("selectedPeriod", "All"));
	  dispatch(scenarioApprovalState("selectedScenarioStatus", "Submitted"));
	  selectedPeriod="All";
	  selectedQuotaStatus= "Submitted";
    }

    let state = {
		selectedCountry,
		selectedCountryID,
		selectedQuotaStatus,
		selectedQuotaStatusKey,
		selectedPeriod,
		duration,
		category:categoryLocal,

	  };	
    // console.log(link, state);
		//navigate(link, { state });
		navigate(linklocal, { state } );
	}


  function getCurrentUpcomingPeriod(data,status) {
	if (!Array.isArray(data)) return null;
  
	const currentPeriods = data
	  .filter(item => item.quotaStatus === status)
	  .map(item => new Date(item.period));
  
	if (currentPeriods.length === 0) return null;
  
	const minDate = new Date(Math.min(...currentPeriods));
	return minDate.toLocaleString("default", { month: "short", year: "numeric" });
  }
  
  

	return (
		<Box
			sx={{
				minHeight: 60,
				width: 340,
				backgroundColor: "#ebedef ",
				p: 1,
				borderRadius: 1,
				fontWeight: "bold",
				m: 1,
			}}
		>
			<Typography variant="subtitle1">{text}</Typography>
			<Typography
				variant="h6"
				align="right"
				color="#21618c"
				sx={{
					fontWeight: "bold",
					textDecoration: link ? "underline" : "none",
					cursor: "pointer",
					pointerEvents: link ? "auto":"none",
				}}
				onClick={navigateTo}
			>
				{number}
			</Typography>
		</Box>
	);
}
